/**
 * Notification Repository Hook
 *
 * Provides access to the notification repository from the context.
 */

import { useRepositoryContext } from '../repositories';
import type { INotificationRepository } from '../repositories/interfaces/INotificationRepository';

/**
 * Hook to access the notification repository
 * Must be used within a RepositoryProvider
 */
export function useNotificationRepository(): INotificationRepository {
  const { notifications } = useRepositoryContext();
  return notifications;
}
